import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingbusrental() {

const cardData = {
keyword: "Wedding Bus Rental Services in Pune",
headingDescription: "Ruturaj Enterprises provides organized wedding bus rental services in Pune for transporting relatives, friends, wedding guests, family members, and event participants between homes, hotels, venues, airports, and other scheduled locations. Wedding transportation often involves multiple functions and several pickup points, so a suitable bus can make group movement more convenient and coordinated. From local marriage functions and reception transfers to destination weddings and outstation celebrations, AC, luxury, and standard bus arrangements can be planned according to the number of guests, itinerary, travel distance, event schedule, and transportation requirements.",
topPlaces: [
{
title: "Lonavala",
description: "Lonavala is a popular destination for weddings, pre-wedding celebrations, and family functions from Pune, and a wedding bus can help transport guests together between hotels, resorts, and event venues. Shared transportation is useful when several relatives and friends need coordinated movement throughout the wedding itinerary."
},
{
title: "Mahabaleshwar",
description: "Destination weddings and family celebrations in Mahabaleshwar can benefit from organized bus transportation from Pune for guests traveling with luggage. A dedicated wedding bus can support transfers between accommodation properties, ceremony venues, reception locations, and planned sightseeing or gathering points."
},
{
title: "Alibaug",
description: "Alibaug is suitable for destination weddings and weekend marriage celebrations, where guests may need transportation from Pune to coastal resorts and wedding venues. A bus rental provides shared travel for relatives and friends while offering practical space for luggage and personal belongings during the journey."
},
{
title: "Nashik",
description: "Pune to Nashik wedding travel can involve multiple guests moving between hotels, function halls, temples, and celebration venues. A wedding bus provides a coordinated group transportation option that helps families manage guest transfers according to ceremony timings and the overall event schedule."
},
{
title: "Goa",
description: "For destination weddings in Goa, a bus can provide convenient transportation for guests traveling from Pune as a group. The spacious arrangement is useful for longer journeys and multi-day celebrations involving airport transfers, hotels, wedding venues, receptions, and other scheduled functions."
},
{
title: "Kolhapur",
description: "Wedding groups traveling from Pune to Kolhapur can use bus transportation for marriage functions, receptions, family gatherings, and traditional ceremonies. Keeping guests together in one vehicle can simplify movement between pickup points, hotels, venues, and other locations included in the wedding itinerary."
},
{
title: "Panchgani",
description: "Panchgani provides a scenic setting for destination weddings and intimate family celebrations, making coordinated transportation important for guests traveling from Pune. A wedding bus can help move relatives and friends comfortably between hotels, resorts, ceremony venues, and nearby locations according to the event plan."
},
{
title: "Dapoli",
description: "Dapoli can be selected for coastal wedding functions and family celebrations requiring group transportation from Pune. A dedicated bus allows guests to travel together with luggage and provides convenient movement between accommodation, beachside venues, event locations, and other planned stops."
},
{
title: "Ganpatipule",
description: "Ganpatipule is suitable for destination marriage functions and family gatherings where guests may travel together from Pune for a multi-day celebration. Wedding bus transportation can support longer-distance guest transfers while providing useful seating and luggage space for the journey."
},
{
title: "Bhandardara",
description: "Bhandardara offers a nature-oriented setting for intimate weddings, family events, and celebration retreats from Pune. A bus rental can simplify group transportation for relatives and guests traveling to resorts, event venues, accommodation facilities, and other locations included in the wedding schedule."
}
],
services: [
{
name: "Wedding Bus Rental Pune",
description: "Wedding bus rental in Pune provides a convenient group transportation solution for relatives, friends, guests, and family members attending marriage ceremonies and related functions. Ruturaj Enterprises can support transportation between homes, hotels, venues, airports, and other scheduled locations according to the wedding itinerary, guest count, and event timings."
},
{
name: "Wedding Bus Hire Pune",
description: "Wedding bus hire in Pune is suitable for families who need organized transportation for guests during ceremonies, receptions, pre-wedding events, and destination celebrations. A shared bus helps keep guests together and can simplify movement between accommodation properties, function venues, pickup points, and other wedding-related locations."
},
{
name: "Wedding Bus Booking Pune",
description: "Wedding bus booking in Pune allows families and event organizers to arrange guest transportation in advance around the wedding date and schedule. Advance planning can include pickup locations, venue transfers, hotel movements, airport requirements, event timings, and return journeys so transportation remains aligned with the overall celebration."
},
{
name: "AC Wedding Bus Rental Pune",
description: "AC wedding bus rental in Pune provides a comfortable air-conditioned environment for guests traveling to marriage functions and destination celebrations. It is useful for local and longer journeys, particularly when relatives and friends need to travel together between hotels, homes, airports, resorts, and wedding venues."
},
{
name: "Luxury Wedding Bus Rental Pune",
description: "Luxury wedding bus rental in Pune offers a premium group transportation option for important guests, family members, relatives, and special wedding programs. The service can be considered for destination weddings, executive guests, reception transfers, hotel movements, and occasions where families prefer a more refined travel arrangement."
},
{
name: "Wedding Guest Bus Rental Pune",
description: "Wedding guest bus rental in Pune helps families organize transportation for groups of relatives and friends attending different wedding functions. Shared travel can reduce individual vehicle coordination while providing a practical way to move guests between homes, hotels, venues, airports, and reception locations."
},
{
name: "Marriage Bus Rental Pune",
description: "Marriage bus rental in Pune is suitable for transporting guests during traditional marriage ceremonies, receptions, engagement functions, family gatherings, and related celebrations. The vehicle can be scheduled around event timings and planned pickup points to help guests reach each function together and on time."
},
{
name: "Wedding Transportation Pune",
description: "Wedding transportation in Pune supports the complete movement requirements of a marriage celebration, including guest transfers, hotel pickups, venue transportation, airport movements, and travel between multiple functions. Ruturaj Enterprises can help organize bus transportation around the wedding itinerary, passenger requirements, and scheduled locations."
},
{
name: "Wedding Guest Transportation Pune",
description: "Wedding guest transportation in Pune provides a convenient solution for relatives, friends, and invited guests who need coordinated travel during marriage celebrations. Bus arrangements can connect accommodation facilities with wedding venues, reception halls, homes, airports, and other locations while keeping groups together."
},
{
name: "Bus Hire for Marriage Pune",
description: "Bus hire for marriage in Pune can be arranged for transporting family members and guests to ceremonies, receptions, pre-wedding events, and destination venues. A suitable bus provides shared seating and practical luggage space while helping organizers manage transportation according to the wedding schedule."
},
{
name: "Bus Rental for Wedding Function Pune",
description: "Bus rental for wedding functions in Pune is useful when guests need transportation between different locations for ceremonies, receptions, haldi, mehendi, sangeet, and other celebrations. Coordinated group travel makes it easier to move guests from hotels, homes, and designated pickup points to each scheduled function."
},
{
name: "Wedding Event Bus Hire Pune",
description: "Wedding event bus hire in Pune provides organized transportation for guests attending large marriage programs and related celebrations. It can support movement between event venues, accommodation properties, airports, restaurants, and other locations while allowing families to maintain a coordinated guest transportation schedule."
},
{
name: "Wedding Group Transportation Pune",
description: "Wedding group transportation in Pune helps relatives, friends, and invited guests travel together instead of depending on numerous separate vehicles. This arrangement can simplify pickup coordination, luggage handling, venue transfers, and return travel during ceremonies, receptions, family gatherings, and destination weddings."
},
{
name: "Wedding Shuttle Bus Rental Pune",
description: "Wedding shuttle bus rental in Pune is useful when guests need repeated transfers between hotels, parking areas, homes, and wedding venues throughout the event. A shuttle arrangement can support different ceremony timings and multiple guest groups while providing convenient transportation during busy wedding schedules."
},
{
name: "Wedding Guest Transfer Pune",
description: "Wedding guest transfer services in Pune provide transportation for relatives and friends moving between airports, hotels, homes, venues, and reception locations. Coordinated bus travel is particularly useful when several guests arrive at different times or when a destination wedding involves multiple accommodation and event locations."
},
{
name: "Bus Rental for Marriage Function Pune",
description: "Bus rental for marriage functions in Pune provides a practical transportation option for family members, relatives, friends, and invited guests attending scheduled celebrations. Travel arrangements can be coordinated around function timings, pickup points, venue locations, and return requirements for a more organized wedding transportation plan."
},
{
name: "Luxury Bus for Wedding Pune",
description: "Luxury bus for wedding requirements in Pune is suitable for families seeking a premium transportation experience for important guests and special wedding movements. It can be used for destination wedding travel, executive guests, reception transfers, hotel-to-venue transportation, and other important functions."
},
{
name: "AC Bus for Wedding Guests Pune",
description: "AC bus for wedding guests in Pune provides comfortable air-conditioned transportation for relatives and friends attending marriage functions. It is suitable for city transfers as well as longer routes to destination wedding locations, offering shared travel for guests along with practical room for luggage and personal belongings."
},
{
name: "Wedding Travel Service Pune",
description: "Wedding travel service in Pune supports transportation requirements across different stages of a marriage celebration, from guest arrival and hotel transfers to ceremony movements and return journeys. Travel planning can be organized around the wedding itinerary, number of guests, pickup points, destinations, and event timings."
},
{
name: "Wedding Bus Service Pune",
description: "Wedding bus service in Pune provides group transportation for marriage ceremonies, receptions, family gatherings, destination weddings, and related functions. A dedicated bus arrangement can help families coordinate guest movement between multiple locations while maintaining a practical and comfortable travel setup."
},
{
name: "Marriage Function Bus Rental Pune",
description: "Marriage function bus rental in Pune is designed for families and event organizers who need shared transportation during wedding celebrations. It can support guest transfers between homes, hotels, function halls, resorts, temples, reception venues, and other locations included in the planned marriage itinerary."
},
{
name: "Wedding Outstation Bus Rental Pune",
description: "Wedding outstation bus rental in Pune is suitable for families arranging transportation to destination weddings and marriage functions outside the city. The bus provides practical group travel for longer journeys while allowing guests to travel together with luggage between Pune and destinations across Maharashtra and nearby regions."
}
],
tableData: [
["Wedding Bus Rental Pune", "Group bus rental for wedding guests, relatives, friends, family members, ceremonies, receptions, and destination celebrations."],
["Wedding Bus Hire Pune", "Convenient wedding bus hire for guest movement between homes, hotels, venues, airports, and marriage functions."],
["Wedding Bus Booking Pune", "Advance bus booking for planned wedding dates, guest transfers, venue movements, hotel pickups, and destination travel."],
["AC Wedding Bus Rental Pune", "Air-conditioned wedding transportation for comfortable local and long-distance guest journeys."],
["Luxury Wedding Bus Rental Pune", "Premium bus option for important guests, family members, destination weddings, and special wedding programs."],
["Wedding Guest Bus Rental Pune", "Shared transportation for relatives and friends attending ceremonies, receptions, and related wedding functions."],
["Marriage Bus Rental Pune", "Practical group transportation for marriage ceremonies, family gatherings, receptions, and traditional functions."],
["Wedding Transportation Pune", "Organized transportation covering guest transfers, hotel movements, airport pickups, venues, and wedding-related locations."],
["Wedding Guest Transportation Pune", "Coordinated guest movement between accommodation, wedding venues, homes, airports, and reception locations."],
["Bus Hire for Marriage Pune", "Group bus hire for family members and guests attending ceremonies, receptions, destination weddings, and pre-wedding events."],
["Bus Rental for Wedding Function Pune", "Wedding function transportation for haldi, mehendi, sangeet, ceremonies, receptions, and other scheduled celebrations."],
["Wedding Event Bus Hire Pune", "Organized bus transportation for large wedding events, venues, hotels, airports, and related locations."],
["Wedding Group Transportation Pune", "Shared transportation that keeps relatives, friends, and wedding guests together during multiple functions."],
["Wedding Shuttle Bus Rental Pune", "Shuttle transportation between hotels, parking areas, homes, venues, and other wedding locations."],
["Wedding Guest Transfer Pune", "Convenient guest transfers between airports, hotels, homes, wedding venues, and reception locations."],
["Bus Rental for Marriage Function Pune", "Group transportation for marriage functions with coordinated pickup points, event venues, and return schedules."],
["Luxury Bus for Wedding Pune", "Premium wedding bus option for important guests, destination celebrations, reception transfers, and special occasions."],
["AC Bus for Wedding Guests Pune", "Comfortable air-conditioned bus transportation for wedding guests traveling locally or to destination venues."],
["Wedding Travel Service Pune", "Wedding travel support covering guest arrivals, hotel transfers, venue movements, ceremonies, and return journeys."],
["Wedding Bus Service Pune", "Dedicated bus service for marriage ceremonies, receptions, family gatherings, and destination wedding transportation."],
["Marriage Function Bus Rental Pune", "Bus rental for transporting family members and guests between homes, hotels, resorts, halls, and marriage venues."],
["Wedding Outstation Bus Rental Pune", "Long-distance wedding transportation for destination celebrations and marriage functions outside Pune."]
],
whychoose: [
{
WhyChooseheading: "Coordinated Guest Movement",
WhyChoosedescription: "Wedding celebrations often involve guests arriving from different places and moving between multiple venues, hotels, and functions. A dedicated bus provides a practical way to coordinate group transportation and helps relatives, friends, and family members travel together according to the planned wedding schedule."
},
{
WhyChooseheading: "Suitable for Multiple Wedding Functions",
WhyChoosedescription: "Marriage celebrations may include haldi, mehendi, sangeet, ceremonies, receptions, family gatherings, and other events held at different locations. Wedding bus arrangements can support repeated transfers between these venues while allowing transportation planning to follow the timing and sequence of the overall celebration."
},
{
WhyChooseheading: "Comfortable Travel for Guests",
WhyChoosedescription: "Guests may travel with traditional outfits, luggage, gifts, and personal belongings, making convenient shared transportation especially useful. Suitable AC or premium bus options provide a comfortable environment for local transfers as well as longer journeys to destination wedding locations."
},
{
WhyChooseheading: "Convenient Hotel and Venue Transfers",
WhyChoosedescription: "Many weddings require guests to move between hotels and function venues several times during the celebration. A bus can provide organized transportation between accommodation properties, homes, ceremony locations, reception halls, airports, and other designated points included in the event itinerary."
},
{
WhyChooseheading: "Useful for Destination Weddings",
WhyChoosedescription: "Destination weddings outside Pune often require transportation for groups traveling over longer distances with luggage. Wedding bus rental provides a shared travel arrangement for relatives and friends heading toward hill stations, coastal destinations, resorts, and other celebration venues across Maharashtra and nearby regions."
},
{
WhyChooseheading: "Options for Different Guest Requirements",
WhyChoosedescription: "Wedding groups can vary considerably in size and travel expectations, so transportation requirements may differ from one function to another. AC, luxury, shuttle, local, and outstation bus arrangements can be planned according to guest numbers, travel distance, event type, and scheduled transfers."
},
{
WhyChooseheading: "Simplified Wedding Transportation Planning",
WhyChoosedescription: "Using group transportation can reduce the need for guests to arrange separate vehicles for every ceremony and venue transfer. Pickup points, event timings, hotel locations, destinations, and return requirements can be considered together to create a more structured transportation plan for the wedding."
},
{
WhyChooseheading: "Support for Complete Wedding Travel",
WhyChoosedescription: "Ruturaj Enterprises supports wedding transportation requirements beginning from Pune for local marriage functions, guest transfers, airport movements, hotel transportation, destination weddings, and outstation celebrations. Arrangements can be planned around the guest count, route, event schedule, and overall travel itinerary for convenient group movement."
}
]
};
















const faqData = [
{
question: "How can I arrange wedding bus rental services in Pune?",
answer: "Wedding bus rental in Pune can be organized by sharing the wedding date, number of guests, pickup locations, venue details, ceremony timings, and required travel schedule. Ruturaj Enterprises can coordinate group transportation between homes, hotels, wedding halls, banquet venues, railway stations, airports, and other locations involved in the wedding itinerary."
},
{
question: "Why is a bus useful for wedding guest transportation in Pune?",
answer: "A dedicated wedding bus allows multiple guests and relatives to travel together instead of arranging several separate vehicles. It can simplify movement between accommodation, ceremony venues, reception locations, and other event points while helping the wedding transportation plan follow the scheduled functions and guest reporting times."
},
{
question: "Can I rent a bus for transporting wedding guests from hotels to the venue?",
answer: "Wedding buses can be scheduled for hotel-to-venue transfers when guests are staying at different accommodations or arriving before the ceremony. Pickup timings can be planned around check-in schedules, wedding rituals, reception programs, and venue reporting requirements so guests have an organized transportation option for the event."
},
{
question: "Can wedding buses be arranged for multiple pickup points in Pune?",
answer: "Multiple pickup locations can be included when relatives and guests are coming from different parts of Pune. A transportation schedule can be prepared according to the guest locations, number of passengers, venue distance, ceremony timing, and expected arrival time, making it easier to coordinate group transfers before the wedding."
},
{
question: "Can I hire a bus for a wedding procession in Pune?",
answer: "A bus can be included in the transportation plan for guests traveling as part of a wedding procession or group movement. The route and timing can be discussed according to the function schedule, gathering point, wedding venue, and return requirements, allowing relatives and guests to travel together during the planned celebration."
},
{
question: "Is wedding bus rental available for outstation wedding guests?",
answer: "Wedding bus rental can also be planned for guests traveling between Pune and destinations outside the city. The arrangement may cover the complete journey, including pickup from Pune, travel to the wedding destination, hotel transfers, local movements during the functions, and the return trip according to the wedding itinerary."
},
{
question: "Can a bus be hired for wedding guests arriving at Pune airport or railway stations?",
answer: "Group transfers can be organized for wedding guests arriving at Pune Airport or railway stations. A bus can be scheduled according to expected arrival timings and then used for transportation to hotels, wedding venues, family residences, or reception locations as required by the event's guest movement plan."
},
{
question: "Can wedding bus rental cover transportation between different functions?",
answer: "The transportation schedule can include multiple wedding functions held at different venues. Guests may need transfers between engagement programs, haldi or mehendi functions, marriage ceremonies, receptions, hotels, and other locations. The route can be planned around the sequence and timing of each event."
},
{
question: "What details are needed to book a wedding bus in Pune?",
answer: "Useful booking details include the wedding date, passenger count, pickup points, venue addresses, function timings, journey distance, number of required transfers, luggage requirements, and return schedule. Providing the complete event itinerary helps Ruturaj Enterprises coordinate transportation around the movement of wedding guests."
},
{
question: "Why choose Ruturaj Enterprises for Wedding Bus Rental Services in Pune?",
answer: "Ruturaj Enterprises arranges group bus transportation for wedding guests, relatives, family members, and event participants across Pune and for planned outstation journeys. The transportation schedule can be structured around multiple pickup points, hotel transfers, ceremony timings, venue changes, airport or railway station arrivals, and return requirements."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohit Bhosale",
feedback:
"We arranged a wedding bus through Ruturaj Enterprises for relatives staying at different hotels in Pune. The transportation plan helped us coordinate everyone's movement to the marriage venue and later to the reception location. Having group transportation made the guest transfers much easier to organize around the function timings.",
rating: 5
},
{
id: 2,
name: "Miss. Kavya Patil",
feedback:
"I used Ruturaj Enterprises for wedding guest transportation when family members were arriving from different locations. The bus arrangement was convenient for moving the group between the railway station, hotel, and wedding venue. It also helped us keep the guest transportation organized during a busy wedding schedule.",
rating: 5
}
];




































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Bus Rental Services in Pune",
  "image": "https://ruturajenterprises.com/assets/images/wedding-bus-rental-services-in-pune.webp",
  "description":
    "Wedding Bus Rental Services in Pune for comfortable and organized transportation of wedding guests, family members, relatives, friends and event teams. Ruturaj Enterprises provides wedding bus rental, hire and booking services with AC, luxury and spacious bus options for marriage ceremonies, receptions, engagement functions, sangeet programs, wedding processions, guest transfers and venue-to-venue travel. Flexible rental plans, experienced drivers and suitable bus sizes make group transportation convenient for local wedding functions, airport transfers, hotel pickups and outstation wedding events from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/wedding-bus-rental-services-in-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Wedding Bus Rental Services in Pune | Wedding Bus Hire Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Wedding Bus Rental Services in Pune for guest transportation, marriage functions, receptions, wedding ceremonies, family travel and venue transfers. Hire AC and luxury wedding buses from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Wedding Bus Rental Pune, Wedding Bus Hire Pune, Wedding Bus Booking Pune, AC Wedding Bus Rental Pune, Luxury Wedding Bus Rental Pune, Wedding Guest Bus Rental Pune, Wedding Guest Bus Hire Pune, Wedding Guest Bus Booking Pune, Wedding Guest Transportation Pune, Wedding Guest Bus Service Pune, Bus for Wedding Pune, Bus for Marriage Pune, Marriage Bus Rental Pune, Marriage Bus Hire Pune, Marriage Bus Booking Pune, Marriage Function Bus Rental Pune, Marriage Function Bus Hire Pune, Marriage Ceremony Bus Pune, Marriage Ceremony Bus Rental Pune, Wedding Transportation Bus Pune, Wedding Transport Service Pune, Wedding Group Transportation Pune, Wedding Guest Transportation Service Pune, Wedding Family Transportation Pune, Wedding Party Bus Rental Pune, Wedding Event Bus Rental Pune, Wedding Event Bus Hire Pune, Wedding Event Bus Booking Pune, Wedding Shuttle Bus Pune, Wedding Shuttle Bus Rental Pune, Wedding Shuttle Bus Hire Pune, Wedding Venue Transfer Bus Pune, Wedding Hotel Transfer Bus Pune, Wedding Airport Transfer Bus Pune, Wedding Airport Pickup Bus Pune, Wedding Airport Drop Bus Pune, Wedding Reception Bus Rental Pune, Wedding Reception Bus Hire Pune, Wedding Reception Bus Booking Pune, Wedding Ceremony Bus Rental Pune, Wedding Ceremony Bus Hire Pune, Wedding Ceremony Bus Booking Pune, Sangeet Function Bus Rental Pune, Sangeet Bus Hire Pune, Engagement Function Bus Rental Pune, Engagement Bus Hire Pune, Wedding Procession Bus Pune, Wedding Procession Bus Rental Pune, Baraat Bus Rental Pune, Baraat Bus Hire Pune, Baraat Transportation Bus Pune, Bridal Family Bus Rental Pune, Groom Family Bus Rental Pune, Family Wedding Bus Pune, Family Wedding Bus Rental Pune, Wedding Bus Service Pune, Wedding Bus Rental Service Pune, Wedding Bus Hire Service Pune, Wedding Bus Booking Service Pune, AC Bus for Wedding Pune, AC Bus for Marriage Pune, Luxury Bus for Wedding Pune, Luxury Bus for Marriage Pune, Premium Wedding Bus Pune, Luxury Wedding Guest Bus Pune, Comfortable Wedding Bus Pune, Wedding Mini Bus Rental Pune, Wedding Mini Bus Hire Pune, Wedding Mini Bus Booking Pune, Mini Bus for Wedding Pune, 20 Seater Bus for Wedding Pune, 25 Seater Bus for Wedding Pune, 26 Seater Bus for Wedding Pune, 32 Seater Bus for Wedding Pune, 35 Seater Bus for Wedding Pune, 40 Seater Bus for Wedding Pune, 45 Seater Bus for Wedding Pune, 50 Seater Bus for Wedding Pune, Wedding Bus for Outstation Pune, Outstation Wedding Bus Rental Pune, Outstation Wedding Bus Hire Pune, Wedding Bus for Family Travel Pune, Wedding Bus for Group Travel Pune, Wedding Bus for Relatives Pune, Wedding Bus for Friends Pune, Wedding Bus for Guests Pune, Wedding Bus with Driver Pune, Wedding Bus Rental with Driver Pune, Wedding Bus Hire with Driver Pune, Wedding Bus Booking with Driver Pune, Wedding Guest Bus with Driver Pune, One Way Wedding Bus Pune, Round Trip Wedding Bus Pune, Local Wedding Bus Rental Pune, Affordable Wedding Bus Rental Pune, Reliable Wedding Bus Hire Pune, Professional Wedding Bus Rental Pune, Wedding Transportation Service Pune, Wedding Bus Rental Company Pune, Wedding Bus Hire Company Pune, Wedding Bus Rental Near Me Pune, Wedding Bus Hire Near Me Pune, Ruturaj Enterprises Wedding Bus Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingbusrental;